import React from 'react';
import { AuthProvider } from './AuthContext';
import { UserProvider } from './UserContext';
import { UIProvider } from './UIContext';
import { CVProvider } from './CVContext';
import { SubscriptionProvider } from './SubscriptionContext';

export * from './AuthContext';
export * from './UserContext';
export * from './UIContext';
export * from './CVContext';
export * from './SubscriptionContext';

export const AppProviders = ({ children }) => (
  <UIProvider>
    <AuthProvider>
      <UserProvider>
        <SubscriptionProvider>
          <CVProvider>{children}</CVProvider>
        </SubscriptionProvider>
      </UserProvider>
    </AuthProvider>
  </UIProvider>
);
